import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jay/Repos/gaoljie/use-swiper/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "installation"
    }}>{`Installation`}</h3>
    <h4 {...{
      "id": "yarn"
    }}>{`yarn`}</h4>
    <pre><code parentName="pre" {...{}}>{`yarn add use-swiper
`}</code></pre>
    <h4 {...{
      "id": "npm"
    }}>{`npm`}</h4>
    <pre><code parentName="pre" {...{}}>{`npm install use-swiper
`}</code></pre>
    <h4 {...{
      "id": "include-css"
    }}>{`include css`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import "use-swiper/lib/swiper.min.css";
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      